import { render, staticRenderFns } from "./AppBase.vue?vue&type=template&id=5f9a33e8&scoped=true"
import script from "./AppBase.vue?vue&type=script&lang=ts"
export * from "./AppBase.vue?vue&type=script&lang=ts"
import style0 from "./AppBase.vue?vue&type=style&index=0&id=5f9a33e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a33e8",
  null
  
)

export default component.exports